import React from "react";
import Image from "next/image";
import { cn } from "@/lib/tailwind";
import { usePdpContext } from "@/providers/PdpProvider";
import { CLink } from "@/components/common/customLink/CustomLink";
import usePdpQueryParams from "@/hooks/usePdpQueryParams";
import { scrollToElementWithOffsets } from "@/apiUtils/commonUtils";

interface USPProps {
  className?: string;
  items: Array<{
    icon: string;
    text: string;
    _type: string;
  }>;
  handleSetSelectedUSP?: (usp: string) => void;
}

export type USPTypes = "shippingCost" | "gift" | "shippingTimeline";

const USPElements = ({ items, className, handleSetSelectedUSP }: USPProps) => {
  const { pdpData, setPdpData } = usePdpContext();
  const { updatePdpQueryParams } = usePdpQueryParams();

  const handleUspClick = (tab: USPTypes) => {
    const tabs: Record<USPTypes, string> = {
      shippingCost: "shippingAndReturn",
      gift: "giftPackaging",
      shippingTimeline: "shippingAndReturn",
    };

    const targetTab = tabs[tab];
    if (targetTab) {
      setPdpData({ ...pdpData, productDetailsTab: targetTab });
      updatePdpQueryParams({ tab: targetTab }, {});
      // Delay scroll to let React finish re-rendering the tab content
      setTimeout(() => {
        scrollToElementWithOffsets("wrapper", ["nav-header", "dynamic-banner"]);
      }, 100);
    }
  };

  return (
    <div
      className={cn(
        "border-b-8 border-t-8 py-7 md:border-b md:border-t-0 md:pb-[30px] md:pt-8",
        className,
      )}
    >
      {items?.map((item, idx) => (
        <button
          key={"usp_" + idx}
          className="flex cursor-pointer items-center gap-2 py-2 md:gap-4"
          onClick={() => handleUspClick(item._type as USPTypes)}
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <Image src={item.icon} alt={item?.text} className="h-4 w-4" width={12} height={12} />
          </span>
          <p className="text-[13px] font-bold underline">{item.text}</p>
        </button>
      ))}
    </div>
  );
};

export default USPElements;